import { render } from "./TheTopNavigationProfileBtn.vue?vue&type=template&id=ee5b1fc2&scoped=true"
import script from "./TheTopNavigationProfileBtn.vue?vue&type=script&lang=js"
export * from "./TheTopNavigationProfileBtn.vue?vue&type=script&lang=js"

import "./TheTopNavigationProfileBtn.vue?vue&type=style&index=0&id=ee5b1fc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee5b1fc2"]])

export default __exports__